import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  activeForm: null, // Default form to open
  activeTab: { name: "", index: 0 },
  changeTab: { name: "", index: 0 },
};

const partnerSlice = createSlice({
  name: "formSwitcher",
  initialState,
  reducers: {
    setActiveForm: (state, action) => {
      state.activeForm = action.payload;
    },
    setActiveTab: (state, action) => {
      state.activeTab = action.payload;
    },
    setChangeTab: (state, action) => {
      state.changeTab = action.payload;
    },
  },
});

export const { setActiveForm, setActiveTab,setChangeTab } = partnerSlice.actions;

export default partnerSlice.reducer;
